import { Box, GridLegacy as Grid, Skeleton, useMediaQuery, useTheme } from '@mui/material'

import React from 'react'

export const MenuItemSkeleton: React.FC<{ count?: number }> = ({ count = 4 }) => {
  const theme = useTheme()
  const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'))
  const skeletonItems = Array.from({ length: count }, (_, skeletonNumber) => skeletonNumber + 1)

  return (
    <Grid container spacing={1.5} data-testid="menu-item-skeleton">
      {skeletonItems.map((skeletonNumber) => (
        <Grid item xs={12} lg={6} key={`menu-item-skeleton-${skeletonNumber}`}>
          <Box
            data-testid="menu-item-skeleton-card"
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              border: (t) => t.borders.light,
              borderRadius: 2,
              p: 2,
              height: isLargeUp ? 140 : 'auto',
            }}>
            <Skeleton
              variant="rectangular"
              width={120}
              height={isLargeUp ? 100 : 160}
              sx={{ borderRadius: 2, flexShrink: 0 }}
            />
            <Box sx={{ flex: 1, width: '100%' }}>
              <Skeleton variant="text" width="70%" height={32} />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="40%" />
              <Skeleton variant="rectangular" height={32} sx={{ borderRadius: 1, mt: 1 }} />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
